import { useEffect } from 'react';

export const useBootstrapCleanup = () => {
  useEffect(() => {
    const hideTooltips = () => {
      const tooltips = document.querySelectorAll('.tooltip, .bs-tooltip-auto');
      tooltips.forEach((tooltip) => tooltip.remove());
    };
    const handleClick = () => {
      setTimeout(hideTooltips, 10);
    };

    document.addEventListener('show.bs.modal', hideTooltips);
    document.addEventListener('click', handleClick);

    return () => {
      document.removeEventListener('show.bs.modal', hideTooltips);
      document.removeEventListener('click', handleClick);
    };
  }, []);
};